import {
    AppBar,
    Box,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Toolbar,
    Typography
} from "@mui/material";
import React from "react";
import {AccountCircle} from "@mui/icons-material";
import {observer} from "mobx-react";

export const MainView = observer((props: {Title: React.ReactNode, Menu: React.ReactNode, Content: React.ReactNode, logout: () => Promise<void>}) => {


    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const settings = [{
        title: "Logout",
        onClick: async () => {
            await props.logout();
        }
    }];

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    return <React.Fragment>
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {props.Title}
                    </Typography>
                    <div>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenUserMenu}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting.title} onClick={setting.onClick}>
                                        <Typography sx={{ textAlign: 'center' }}>{setting.title}</Typography>
                                    </MenuItem>
                                ))}
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Paper sx={{ width: 200, height: "calc(100vh - 64px)", position: "absolute", borderRadius: "0", overflow: "auto"}}>
                {props.Menu}
            </Paper>
            <Box sx={{marginLeft: "200px", height: "calc(100vh - 64px)", overflow: "auto", backgroundColor: "#f0f0f0"}}>
                {props.Content}
            </Box>
        </Box>
    </React.Fragment>;
});

